import React from "react";
import "./bodyCardEventSlider.sass";

export default function Momios({ momioL, momioR, momioM, urlMomioL, urlMomioR, urlMomioM, urlEvento }) {

    return (
        <>
            {!momioL && !momioR && !momioM
                ? <a className="container-sinmomios-slider" href={urlEvento} target="_top"> </a>
                :
                <div className="container-momios-slider">
                    {String(momioL).trim().length > 0 && String(urlMomioL).length > 0 
                        ? <a href={urlMomioL} target="_blank" rel="noreferrer" className={"momios-slider momioL"}> {momioL} </a> 
                        : String(momioL).trim().length > 0 && String(urlMomioL).length === 0 && <p className={"momios-slider momioL"}> {momioL} </p>  
                    }

                    {String(momioM).trim().length > 0 && String(urlMomioM).length > 0
                        ? <a href={urlMomioM} target="_blank" rel="noreferrer" className="momios-slider momioM"> {momioM} </a> 
                        : String(momioM).trim().length > 0 && String(urlMomioM).length === 0
                            ? <p className="momios-slider momioM"> {momioM} </p> 
                            : <p className="momios-slider momioM"></p>
                    }

                    {String(momioR).trim().length > 0  && String(urlMomioR).length > 0 
                        ? <a href={urlMomioR} target="_blank" rel="noreferrer" className="momios-slider momioR"> {momioR} </a>
                        : String(momioR).trim().length > 0 && String(urlMomioR).length === 0 && <p className={"momios-slider momioR"}> {momioR} </p>  
                    }
                </div>
            }
        </>
    )
}

